export const getIndexFromUrnTypesFieldName = (name: string): number => {
  return parseInt(name.replace('urnTypes[', '').replace(']', ''), 10)
}
